import React from "react"
import Rescuer from "components/Rescuer"
import useRescuers from "hooks/useRescuers"
import "./RosterMember.css"

const ROLES = [
    {value: 'head', label: 'Šef smene'},
    {value: 'member', label: 'Član'},
    {value: 'trainee', label: 'Tečajac'},
    {value: 'snowmobiler', label: 'Sankaš'}
]

const getRoleLabel = (role) => {
    const found = ROLES.find(r => r.value === role)
    return found ? found.label : role
}

const getRoleClass = (role) => {
    if (role === 'head') return 'role-head'
    if (role === 'trainee') return 'role-trainee'
    if (role === 'snowmobiler') return 'role-snowmobiler'
    return 'role-member'
}

export default function RosterMember(props) {

    const {member, index, onRemove, onSetRole, canEdit, notes, onSetNotes} = props
    const {getUser, hasTag} = useRescuers()
    const rescuer = getUser(member.username) || member.rescuer

    if (!rescuer) return null

    return <div className="roster-member-row">
        <span className="member-number">{index + 1}.</span>
        <Rescuer rescuer={rescuer} onClick="profile"/>
        <div className="member-badges">
            {!hasTag(rescuer.username, 'tečajac') && !rescuer.coef && <span className="badge warning-badge">Licenca</span>}
            {!hasTag(rescuer.username, 'tečajac') && !rescuer.membership_paid && <span className="badge warning-badge">Članarina</span>}
            {!hasTag(rescuer.username, 'tečajac') && !rescuer.ski && <span className="badge warning-badge">Skijanje</span>}
            {member.source === 'manual' && <span className="badge source-badge source-manual">Ručno</span>}
        </div>
        {canEdit && <div className="member-actions">
            <select className="role-select" value={member.role} onChange={e => onSetRole(member, e.target.value)}>
                {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
            <button className="member-remove" onClick={() => onRemove(member)} title="Ukloni iz smene"><i className="fas fa-times"/></button>
        </div>}
        {!canEdit && <span className={`badge role-badge ${getRoleClass(member.role)}`}>{getRoleLabel(member.role)}</span>}
        {canEdit && <div className="member-notes-row">
            <input className="member-notes-input" type="text" value={notes || ''} onChange={e => onSetNotes(member, e.target.value)} placeholder="Napomena"/>
        </div>}
        {!canEdit && notes && <div className="member-notes-row">
            <span className="member-notes-text">{notes}</span>
        </div>}
    </div>

}
